import React, { useRef, useEffect } from "react";

const Modal = ({ handleClose, show, children }) => {
  const modalRef = useRef();
  const modalClasses = show
    ? "absolute w-full h-full top-0 left-0 bg-dark-blue block z-[1000] flex items-center justify-center"
    : "opacity-0";

  useEffect(() => {
    if (show) {
      modalRef.current.focus();
    }
  });

  return (
    <dialog className={modalClasses} ref={modalRef} aria-live="polite">
      <button
        id="modal-btn"
        className="text-2xl block hover:opacity-75 absolute right-0 top-0 bg-dark-blue text-white px-2 py-1 z-[10000] lg:w-[50px] lg:h-[50px] pointer-events-auto focus:border-2"
        onClick={handleClose}
        autoFocus
      >
        <span className="material-symbols-rounded text-white text-4xl font-black">close</span>
      </button>
      {children}
    </dialog>
  );
};

export default Modal;
